import React, { useEffect, useState } from "react";
import BooksNavbar from "./BooksNavbar";
import BooksFooter from "./BooksFooter";
import { getLinks } from "../api/linkApi";
import { getVideos } from "../api/videoApi";

const BooksNews = () => {
  const [newsItems, setNewsItems] = useState([]);
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  const category = "Books News";

  const getImageSrc = (imageUrl) => {
    if (!imageUrl) return "/default-placeholder.png";

    if (imageUrl.startsWith("http")) {
      return imageUrl;
    }

    const serverUrl = process.env.REACT_APP_API_URL.replace("/api", "");

    return `${serverUrl}${imageUrl}`;
  };

  const getVideoSrc = (video) => {
    if (video.fileUrl) {
      const serverUrl = process.env.REACT_APP_API_URL.replace("/api", "");
      return `${serverUrl}${video.fileUrl}`;
    }

    if (video.url?.includes("watch?v=")) {
      return video.url.replace("watch?v=", "embed/");
    }

    return video.url;
  };

  useEffect(() => {
    // const fetchNews = async () => {
    //   try {
    //     const links = await getLinks(category);

    //     const sortedLinks = links.sort(
    //       (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    //     );

    //     setNewsItems(sortedLinks);
    //   } catch (error) {
    //     console.error("Error fetching book news:", error);
    //     setNewsItems([]);
    //   } finally {
    //     setLoading(false);
    //   }
    // };

    const fetchNews = async () => {
      try {
        const [links, videos] = await Promise.all([
          getLinks(category),
          getVideos(category),
        ]);

        const combinedItems = [
          ...links.map((item) => ({ ...item, itemType: "link" })),
          ...videos.map((item) => ({ ...item, itemType: "video" })),
        ].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

        setNewsItems(combinedItems);
      } catch (error) {
        console.error("Error fetching book news:", error);
        setNewsItems([]);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  return (
    <div>
      {/* NEWS PAGE */}
      <section className="relative min-h-screen bg-white overflow-hidden">
        <BooksNavbar textColor="black" />

        <div className="relative z-10 pt-32 pb-20">
          <div className="max-w-7xl mx-auto px-6 md:px-12">
            {/* Page heading */}
            <div className="text-center mb-14">
              <p
                className="text-xs tracking-[0.35em] text-[#8c8b5f] mb-4 uppercase"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                News
              </p>

              <h1
                className="text-5xl md:text-7xl text-black leading-tight mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Latest updates.
              </h1>

              <div className="flex items-center w-full max-w-sm mx-auto mb-8">
                <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
                <span className="px-4 text-[#8c8b5f] text-lg">❖</span>
                <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              </div>

              <p
                className="text-xl md:text-2xl italic text-[#5f6f4f] leading-relaxed max-w-3xl mx-auto"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                News, interviews, reviews, events, and updates for{" "}
                <em>Think Before You Think</em>.
              </p>
            </div>

            {/* News items */}
            {loading ? (
              <p
                className="text-center text-gray-600"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Loading news...
              </p>
            ) : newsItems.length === 0 ? (
              <div className="bg-[#f5f3ef] p-10 text-center max-w-3xl mx-auto">
                <h2
                  className="text-3xl text-black mb-4"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  News coming soon.
                </h2>

                <p
                  className="text-gray-700 leading-relaxed"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Updates, interviews, reviews, and events will appear here once
                  they are added.
                </p>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {/* {newsItems.map((news) => (
                  <a
                    key={news._id}
                    href={news.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block bg-[#f5f3ef] overflow-hidden shadow-sm hover:shadow-lg transition duration-300"
                  >
                    <div className="relative">
                      <img
                        src={getImageSrc(news.imageUrl)}
                        alt={news.title}
                        className="w-full h-56 object-cover"
                        onError={(e) => {
                          e.currentTarget.onerror = null;
                          e.currentTarget.src = "/default-placeholder.png";
                        }}
                      />

                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                    </div>

                    <div className="p-6">
                      <p
                        className="text-xs tracking-[0.25em] text-[#D4AF37] mb-3 uppercase"
                        style={{ fontFamily: "Playfair Display, serif" }}
                      >
                        News
                      </p>

                      <h2
                        className="text-xl text-black leading-snug mb-4"
                        style={{ fontFamily: "Playfair Display, serif" }}
                      >
                        {news.title}
                      </h2>

                      <p
                        className="text-sm text-[#8c8b5f] font-semibold tracking-widest"
                        style={{ fontFamily: "Playfair Display, serif" }}
                      >
                        READ MORE →
                      </p>
                    </div>
                  </a>
                ))} */}
                {newsItems.map((item) =>
                  item.itemType === "video" ? (
                    <div
                      key={item._id}
                      className="block bg-[#f5f3ef] overflow-hidden shadow-sm hover:shadow-lg transition duration-300"
                    >
                      <iframe
                        className="w-full h-56"
                        src={getVideoSrc(item)}
                        title={item.title}
                        allowFullScreen
                      />

                      <div className="p-6">
                        <p
                          className="text-xs tracking-[0.25em] text-[#D4AF37] mb-3 uppercase"
                          style={{ fontFamily: "Playfair Display, serif" }}
                        >
                          Video
                        </p>

                        <h2
                          className="text-xl text-black leading-snug mb-4"
                          style={{ fontFamily: "Playfair Display, serif" }}
                        >
                          {item.title}
                        </h2>
                      </div>
                    </div>
                  ) : (
                    <a
                      key={item._id}
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block bg-[#f5f3ef] overflow-hidden shadow-sm hover:shadow-lg transition duration-300"
                    >
                      <div className="relative">
                        <img
                          src={getImageSrc(item.imageUrl)}
                          alt={item.title}
                          className="w-full h-56 object-cover"
                          onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = "/default-placeholder.png";
                          }}
                        />

                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                      </div>

                      <div className="p-6">
                        <p
                          className="text-xs tracking-[0.25em] text-[#D4AF37] mb-3 uppercase"
                          style={{ fontFamily: "Playfair Display, serif" }}
                        >
                          News
                        </p>

                        <h2
                          className="text-xl text-black leading-snug mb-4"
                          style={{ fontFamily: "Playfair Display, serif" }}
                        >
                          {item.title}
                        </h2>

                        <p
                          className="text-sm text-[#8c8b5f] font-semibold tracking-widest"
                          style={{ fontFamily: "Playfair Display, serif" }}
                        >
                          READ MORE →
                        </p>
                      </div>
                    </a>
                  ),
                )}
              </div>
            )}
          </div>
        </div>
      </section>

      <BooksFooter />
    </div>
  );
};

export default BooksNews;
